import React from 'react';
import ReactDOM from 'react-dom';
import MfaForm from './MfaForm.tsx';
import AuthService from '../../../auth/auth.service';

export default angular
  .module('components.tb.mfaForm', ['react'])
  .directive('tbMfaForm', (reactDirective, $auth, $state, AuthService) => reactDirective(MfaForm, [], {}, { $auth, $state, AuthService }))